export type ReportFilter = "all" | "created" | "subscribed" | "shared";

const OPTIONS: Array<{ value: ReportFilter; label: string }> = [
  { value: "all", label: "All" },
  { value: "created", label: "Created" },
  { value: "subscribed", label: "Subscribed" },
  { value: "shared", label: "Shared" },
];

type ReportFilterControlProps = {
  value: ReportFilter;
  onChange: (value: ReportFilter) => void;
  counts: Record<ReportFilter, number>;
};

export default function ReportFilterControl({ value, onChange, counts }: ReportFilterControlProps) {
  return (
    <fieldset className="mb-4 overflow-x-auto pb-0.5">
      <legend className="sr-only">Filter my reports</legend>
      <div className="inline-grid min-w-max grid-cols-4 overflow-hidden rounded-lg border border-gray-200 bg-gray-50 p-0.5">
        {OPTIONS.map((option) => (
          <label key={option.value} className="cursor-pointer">
            <input
              type="radio"
              name="my-reports-filter"
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className="peer sr-only"
            />
            <span className="flex min-h-8 items-center justify-center gap-1.5 rounded-md px-3 text-xs font-medium text-gray-500 transition-colors hover:text-gray-700 peer-checked:bg-white peer-checked:text-blue-700 peer-checked:shadow-sm peer-focus-visible:underline peer-focus-visible:decoration-2 peer-focus-visible:underline-offset-4">
              {option.label}
              <span className="text-[11px] text-gray-400">{counts[option.value]}</span>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
